export default __webpack_public_path__ + "src/images/packages/emily-moon-lodge/4ed4a8b7159183becf0526e506ad85ca-4.jpg";